import React, { useRef, useEffect, useState } from 'react'
import {
    Box,
    Grid,
    Typography,
    Skeleton,
    Card
} from '@mui/material'
import { Image, Carousel } from 'antd'
import IconLeft from '../../../assets/home/icon_left.png'
import IconRight from '../../../assets/home/icon_right.png'
import { isTablet } from 'react-device-detect'
import axios from 'axios'
import { NewsUrl } from '../../../common/url'
import { ROOT_PATH, App_Language_key } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMHomeWhatsNew: React.FC = () => {

    const { t } = useTranslation()

    const carouselRef = useRef(null)

    const [data, setData] = useState([])

    const next = () => {
        carouselRef.current.next()
    }

    const prev = () => {
        carouselRef.current.prev()
    }

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async () => {
        try {
            const response = await axios.get(NewsUrl + '?pagination[page]=1&pagination[pageSize]=6&sort=sequence:ASC&publicationState=live&filters[language][$eq]=' + language)
            var list = response.data['data']
            setData(chunkArray(list.length > 6 ? list.slice(0, 6) : list, 3))
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const chunkArray = (array, size) => {
        const result = []
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size))
        }
        return result
    }

    const detail = (id: number) => {
        window.open(ROOT_PATH + '/news-detail?id=' + id)
    }

    const carouselBodyItem = () => {
        return (
            <Box sx={{ width: '100%', position: 'relative', paddingTop: '30px' }}>
                <Carousel dots={false} ref={carouselRef}>
                    {data.map((item, index) => (
                        renderCarouselItem(index)
                    ))}
                </Carousel>

                <Box sx={{ position: 'absolute', top: '30%', bottom: '70%', left: '0px' }}>
                    <Box onClick={() => prev()} sx={{ width: '60px', height: '60px', backgroundColor: 'rgba(0, 0, 0, 0.3)', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', borderRadius: '30px', cursor: 'pointer' }}>
                        <Image src={IconLeft} width={32} height={32} alt='' preview={false}></Image>
                    </Box>
                </Box>

                <Box sx={{ position: 'absolute', top: '30%', bottom: '70%', right: '0px' }}>
                    <Box onClick={() => next()} sx={{ width: '60px', height: '60px', backgroundColor: 'rgba(0, 0, 0, 0.3)', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', borderRadius: '30px', cursor: 'pointer' }}>
                        <Image src={IconRight} width={32} height={32} alt='' preview={false}></Image>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderCarouselItem = (index: number) => {
        return (
            <Box key={index} sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <Grid
                    container
                    columnSpacing={2}
                    rowSpacing={2}
                >
                    {data[index].map((subItem, subIndex) => (
                        renderCarouselCardItem(index, subIndex)
                    ))}
                </Grid>
            </Box>
        )
    }

    const renderCarouselCardItem = (superIndex: number, index: number) => {
        return (
            <Grid item key={index} xs={4}>
                <Box
                    onClick={() => detail(data[superIndex][index]['id'])}
                    sx={{
                        width: '100%',
                        height: '100%',
                        borderRadius: 6,
                        cursor: 'pointer',
                        paddingLeft: '12px',
                        paddingRight: '12px',
                    }}>
                    <Card
                        style={{
                            borderRadius: '4px',
                            boxShadow: 'none',
                            border: 'none',
                            '&:hover': {
                                boxShadow: 'none'
                            }
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: data[superIndex][index]['attributes']['image'] }} />
                    </Card>
                    <Typography fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} sx={{
                        paddingTop: '35px'
                    }}>
                        {data[superIndex][index]['attributes']['Description']}
                    </Typography>
                    <Typography fontWeight={700} fontSize={'20px'} color={'#141F39'} sx={{
                        paddingTop: '6px'
                    }}>
                        {data[superIndex][index]['attributes']['title']}
                    </Typography>
                    <Typography fontWeight={500} fontSize={'16px'} color={'#6B6B6B'} sx={{
                        paddingTop: '6px'
                    }}>
                        {t('t76')}
                    </Typography>
                </Box>
                {/* </Box> */}
            </Grid>
        )
    }

    const skeletonData = [
        '',
        '',
        ''
    ]

    const skeletonItem = () => {
        return (
            <Box sx={{paddingTop: '30px'}}>
                <Grid container columnSpacing={2} rowSpacing={6}>
                    {skeletonData.map((item, index) => (
                        skeletonCard(index)
                    ))}
                </Grid>
            </Box>
        )
    }

    const skeletonCard = (index: number) => {
        return (
            <Grid item key={index} xs={4}>
                <Box>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }} ></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                </Box>
            </Grid>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingLeft: isTablet ? '16px' : '60px',
            paddingRight: isTablet ? '16px' : '60px',
            paddingBottom: '30px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontWeight={700} fontSize={'32px'} color={'#141F39'}>
                    {t('t75')}
                </Typography>
            </Box>

            {data === null || data.length === 0 ? skeletonItem() : carouselBodyItem()}
        </Box>
    )
}

// ======================= EXPORT
export default SMHomeWhatsNew
